import {
  COUNTRY,
  COUNTRY_FLAG,
  COUNTRY_LABEL,
  OTHER_COUNTRY,
} from '@/config/country';
import { goToCountryPanel } from '@/config/countryChoice';

interface Props {
  email?: string | null;
  onLogout?: () => void;
}

/**
 * El token es válido pero el usuario no existe en la base de ESTE país.
 *
 * Pasa cuando alguien de Uruguay entra al panel de Perú: el servicio de auth es
 * el mismo para los dos, así que la sesión se acepta, pero cada país tiene su
 * propia base de usuarios y el `whoami` responde 404.
 *
 * No se cierra la sesión: la cuenta está bien, sólo que en otro país. Cerrarla
 * obligaría a loguearse de nuevo al volver, que es justo lo que se quiere
 * evitar.
 */
const NoCountryAccountScreen = ({ email, onLogout }: Props) => (
  <div className='flex min-h-screen w-full items-center justify-center bg-gray-50 p-6'>
    <div className='max-w-md rounded-lg border border-gray-200 bg-white p-8 text-center shadow-sm'>
      <img
        src={COUNTRY_FLAG[COUNTRY]}
        alt=''
        className='mx-auto mb-4 h-10 w-10 rounded-full object-cover'
      />
      <h1 className='mb-3 text-xl font-semibold text-gray-800'>
        Tu cuenta no está asociada al panel de {COUNTRY_LABEL[COUNTRY]}
      </h1>
      <p className='text-sm text-gray-600'>
        {email ? <strong>{email}</strong> : 'Tu usuario'} tiene sesión iniciada,
        pero no está dado de alta en {COUNTRY_LABEL[COUNTRY]}. Cada país tiene
        sus propios usuarios.
      </p>

      <button
        type='button'
        onClick={() => goToCountryPanel(OTHER_COUNTRY)}
        className='mt-6 inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700'
      >
        <img
          src={COUNTRY_FLAG[OTHER_COUNTRY]}
          alt=''
          className='h-5 w-5 rounded-full object-cover'
        />
        Ir a sitio de {COUNTRY_LABEL[OTHER_COUNTRY]}
      </button>

      <p className='mt-4 text-xs text-gray-500'>
        Si necesitás operar en {COUNTRY_LABEL[COUNTRY]}, pedile a un
        administrador que te dé de alta.
      </p>

      {onLogout && (
        <button
          type='button'
          onClick={onLogout}
          className='mt-4 cursor-pointer text-xs text-gray-500 underline transition-colors hover:text-gray-700'
        >
          Cerrar sesión
        </button>
      )}
    </div>
  </div>
);

export default NoCountryAccountScreen;
